//Modules
import React, { useState } from "react"
//Animation
import Slide from "react-reveal/Slide"
import Fade from "react-reveal/Fade"
//Styled Components
import styled from "styled-components"
import {
  maxContentWidth,
  flex,
  font,
  colors,
  spacing,
  boxShadow,
} from "../../../Utilities"
//Icons
import { FaBars } from "react-icons/fa"
//Components
import Logo from "./Logo"
import NavMenu from "./NavMenu"
import MobileNavMenu from "./MobileNavMenu"

const Header = () => {
  const [menuStatus, toggleMenuStatus] = useState(false)

  const handleClick = () => {
    toggleMenuStatus(!menuStatus)
  }

  return (
    <StyledHeader>
      <div className="header-content-container">
        <Logo />
        <NavMenu />

        <Slide right when={menuStatus}>
          {menuStatus && (
            //Styles in base.css
            <nav className="mobile-nav">
              <MobileNavMenu />
            </nav>
          )}
        </Slide>

        <Fade big when={menuStatus}>
          {menuStatus && (
            //STYLES IN BASE.CSS
            <div
              className="backdrop"
              onClick={() => {
                toggleMenuStatus(false)
              }}
              onKeyPress={e => {
                if (e.keyCode === 13) {
                  toggleMenuStatus(false)
                }
              }}
              role="button"
              tabIndex="0"
            />
          )}
        </Fade>

        <StyledMobileButtonContainer onClick={handleClick}>
          <FaBars />
        </StyledMobileButtonContainer>
      </div>
    </StyledHeader>
  )
}

const StyledHeader = styled.header`
  background: white;
  width: 100vw;
  height: 15vh;
  /* border-bottom: 0.1rem solid ${colors.primary}; */
  position: relative;
  box-shadow: ${boxShadow.dark};

  .header-content-container {
    ${flex("row", "space-between", "center")};
    height: 100%;
    margin: 0 auto;
    max-width: ${maxContentWidth};
  }
`

const StyledMobileButtonContainer = styled.div`
  ${font("L")};
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-right: ${spacing.M};
  z-index: 2000;
  background: none;
  border: none;

  @media (min-width: 768px) {
    ${font("XXL")};
    margin-right: ${spacing.L};
  }

  @media (min-width: 1200px) {
    display: none;
  }
`

export default Header
